module.exports = __webpack_public_path__ + "img/picture-folder.f7c869ac.png";